import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import PartnershipWithPFSLabel from "app/pages/.shared/PartnershipWithPFSLabel/PartnershipWithPFSLabel";
import { memo } from "react";
import "./ListingActionbar.scss";
import PaymentDescriptionTermsContainer from "app/pages/Booking/Payment/PaymentDescriptionTerms/PaymentDescriptionTermsContainer";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const ListingActionbar = ({ count, showPfsMessage, hidePaymentDescriptionBlock }) => {
	return (
		<div className="listing-actionbar">
			{showPfsMessage && <PartnershipWithPFSLabel />}

			{count > 0 && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.XL3}
					variantMD={TYPOGRAPHY_VARIANTS.XL4}
					isBold
					className="listing-actionbar__counter"
					data-testid="listing-actionbar-count"
					component="h1"
				>
					<FormattedMessage id="listing.products.current.label" />
				</Typography>
			)}
			{!hidePaymentDescriptionBlock && <PaymentDescriptionTermsContainer />}
		</div>
	);
};

ListingActionbar.propTypes = {
	count: PropTypes.number,
	showPfsMessage: PropTypes.bool,
	hidePaymentDescriptionBlock: PropTypes.bool,
};

export default memo(ListingActionbar);
